import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";
import { Switch } from "@/components/ui/switch";

interface ProgressSliderWithToggleProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
}

export function ProgressSliderWithToggle({ label, value, onChange }: ProgressSliderWithToggleProps) {
  const isNA = value === -1;

  const handleToggleNA = (checked: boolean) => {
    onChange(checked ? -1 : 0);
  };

  const handleSliderChange = ([newValue]: number[]) => {
    onChange(newValue);
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label className="text-sm font-medium">{label}</Label>
        <div className="flex items-center gap-3">
          {/* N/A Toggle Switch */}
          <div className="flex items-center gap-2">
            <Label htmlFor={`na-${label}`} className="text-xs text-muted-foreground cursor-pointer">
              N/A
            </Label>
            <Switch
              id={`na-${label}`}
              checked={isNA}
              onCheckedChange={handleToggleNA}
            />
          </div>
          {/* Percentage Display */}
          <span className="w-12 text-right text-sm font-mono tabular-nums">
            {isNA ? "(0)" : `${value}%`}
          </span>
        </div>
      </div>

      {/* Slider - disabled when N/A */}
      <Slider
        value={[isNA ? 0 : value]}
        onValueChange={handleSliderChange}
        disabled={isNA}
        min={0}
        max={100}
        step={5}
        className={isNA ? "opacity-30 cursor-not-allowed" : ""}
      />
    </div>
  );
}
